import {
  Box,
  Button,
  Grid2,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import loginBackground from "./../../assets/images/loginBackground.png";
import InputBase from "@mui/material/InputBase";
import jccLogo from "./../../assets/images/jccLogo.png";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import * as Yup from "yup";
import { mobileNumberRegex } from "../../uttils/RegexPattern";
import {
  useGetOTPMutation,
  useVerifyOTPMutation,
} from "../../services/authenticationAPI";
import { useNavigate } from "react-router-dom";
import CustomSnackbar, {
  ErrorSnackBar,
  SuccessSnackBar,
} from "../../components/SnackBar";
import OTP from "../../components/OTP";
import { toast } from "react-toastify";
import { saveToken, saveUserPref } from "../../uttils/UserPref";
import { useDispatch } from "react-redux";
import { setToken, setUser } from "../../redux/slices/user/userSlice";

const styles = {
  selectedTab: {
    overflow: "hidden",
    borderRadius: "33px",
    borderColor: "#F7F8F9",
    flex: 1,
    width: "21.5%",
    height: "10%",
    color: "#fff",
  },
  unSelectedTab: {
    overflow: "hidden",
    borderRadius: "33px",
    flex: 1,
    width: "21.5%",
    height: "10%",

    background: "#F7F8F9",
    // marginRight: "13px",
    color: "#1E232C",
  },
  getOTP: {
    width: "21rem",
    height: "3rem",
    overflow: "hidden",
    borderRadius: "9px",
    borderColor: "#F7F8F9",
    textTransform: "initial",
    background:
      "var(--Grad, linear-gradient(96deg, #DA5332 -5.2%, #DA5332 -5.19%, #F78524 113.53%))",
    color: "#fff",
  },
};

const Auth = () => {
  const [loginTabSelected, setLoginTabSelected] = useState(true);
  const [snackState, setSnackState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [getOTP] = useGetOTPMutation();
  const [verifyOTP] = useVerifyOTPMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    mobileNumber: Yup.string()
      .matches(mobileNumberRegex, "Must be a valid mobile number")
      .length(10, "Invalid mobile number")
      .required("Mobile number is required"),
  });

  const _selectTab = (login) => {
    setShowOTPInput(false);
    login ? setLoginTabSelected(true) : setLoginTabSelected(false);
  };

  console.log("Auth");

  const _login = async (values, actions) => {
    const data = {
      type: "login",
      phone: values.mobileNumber,
      phoneArea: "91",
    };

    const res = await getOTP(data);

    if (res?.data?.success) {
      setShowOTPInput(true);
      toast.success("OTP sent successfully");
    } else {
      toast.error("Something went wrong");
    }
  };

  const _verifyOTP = async (values) => {
    if (!otp || otp.length < 6) {
      toast.error("OTP is required");
      return;
    }

    const payload = {
      phone: values?.mobileNumber,
      phoneArea: "91",
      otp: otp,
    };

    const res = await verifyOTP(payload);

    const datas = res?.data;

    if (res?.data?.success) {
      // const userId = res?.data?.data?.user?._id;

      const token = res?.data?.data?.accessToken;
      const refreshToken = res?.data?.data?.refreshToken;

      localStorage.setItem("accessToken", token);
      localStorage.setItem("refreshToken", refreshToken);
      saveToken(token);
      saveUserPref(res?.data?.data);

      dispatch(setUser(res?.data?.data?.user));
      dispatch(setToken(token));
      navigate("/user/home", { replace: true });

      // Moengage
      // const currentUser = res?.data?.data?.user;
      // const firstName = currentUser?.name.split(" ")[0];
      // const lastName = currentUser?.name.split(" ")[1];
      // ReactMoE.requestPushPermissionAndroid();
      // ReactMoE.setUserUniqueID(userId);
      // ReactMoE.setUserName(
      //   currentUser?.firstName + ' ' + currentUser?.lastName,
      // );
      // ReactMoE.setUserFirstName(firstName);
      // ReactMoE.setUserLastName(lastName);
      // ReactMoE.setUserEmailID(currentUser?.email);
      // ReactMoE.setUserContactNumber(currentUser?.phone);
      // ReactMoE.setUserGender(currentUser?.gender);
      //   try {
      //     const seen = await AsyncStorage.getItem(onBoardingKey);
      //     console.log("seen", seen);
      //     // if (JSON.parse(seen) == true) {
      //     navigation.pop();
      //     navigation.replace("DrawerNavigator", { datas });
      //     // } else {
      //     //   navigation.pop();
      //     //   navigation.replace('OnBoarding', { datas });
      //     // }
      //   } catch (err) {
      //     console.log("Error in key", err);
      //   }
    }

    // Moengage
    else if (res?.error?.data?.message) {
      toast.error(res?.error?.data?.message);
    } else {
      toast.error("Something went wrong");
    }
  };

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Grid2 container direction={"row"} sx={{ width: "100%", height: "100%" }}>
        <Grid2
          size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}
          sx={{ width: "100%", height: "100%" }}
        >
          <Box
            sx={{
              height: "100%",
              backgroundImage: `url(${loginBackground})`,
              backgroundSize: "100% 100%",
            }}
          >
            <Typography
              sx={{
                position: "absolute",
                fontSize: {
                  xl: "4.5rem",
                  lg: "3.2rem",
                  md: "3.5rem",
                  sm: "2.5rem",
                  xs: "2rem",
                },
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                color: "white",
                bottom: {
                  xl: "5rem",
                  lg: " 4.5rem",
                  md: "16rem",
                  sm: "12rem",
                  xs: "10rem",
                },
                left: {
                  xl: "5rem",
                  lg: " 6rem",
                  md: "10rem",
                  sm: "8rem",
                  xs: "4rem",
                },
              }}
            >
              Unleash the Roar,{<br />} Chase the Glory!
            </Typography>
          </Box>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}>
          <Box sx={{ height: "100vh" }}>
            <Box
              sx={{
                height: "219px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <img src={jccLogo} style={{ height: "139px", width: "85px" }} />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography className={"WelcomeToJCCSprtsTitle"}>
                Welcome to JCC SPRTS
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  maxWidth: "20rem",
                  margin: "5% 10%",
                  display: "flex",
                  borderRadius: "33px",
                  overflow: "hidden",
                  backgroundColor: "#F7F8F9",
                  borderColor: "#F7F8F9",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <Button
                  className={loginTabSelected ? "selectedTab" : "unSelectedTab"}
                  sx={{
                    flex: 1,
                    // paddingX: "5rem",
                    paddingY: "0.6rem",
                    textTransform: "initial",
                  }}
                  onClick={() => _selectTab(true)}
                >
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      color: loginTabSelected ? "#fff" : "#000",
                    }}
                  >
                    Login
                  </Typography>
                </Button>
                <Button
                  onClick={() => _selectTab(false)}
                  sx={{
                    flex: 1,
                    // paddingX: "5rem",
                    paddingY: "0.6rem",
                    textTransform: "initial",
                  }}
                  className={
                    !loginTabSelected ? "selectedTab" : "unSelectedTab"
                  }
                >
                  <Typography
                    sx={{
                      fontSize: "1em",
                      color: !loginTabSelected ? "#fff" : "#000",
                    }}
                  >
                    Register
                  </Typography>
                </Button>
              </Box>
            </Box>

            <Formik
              initialValues={{
                mobileNumber: "",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, actions) => {
                showOTPInput ? _verifyOTP(values) : _login(values, actions);
              }}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                touched,
              }) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {showOTPInput ? (
                    <OTP
                      separator={<span>-</span>}
                      value={otp}
                      onChange={setOtp}
                      length={6}
                    />
                  ) : (
                    <TextField
                      error={touched.mobileNumber && errors.mobileNumber}
                      name="mobileNumber"
                      onChange={(event) =>
                        handleChange("mobileNumber")(event.target.value)
                      }
                      color="warning"
                      sx={{
                        width: "21rem",
                        mb: 4,
                        mt: 2,
                      }}
                      fullWidth
                      label="Enter your mobile number"
                      type="text"
                      value={values.mobileNumber}
                      helperText={
                        touched.mobileNumber &&
                        errors.mobileNumber &&
                        errors.mobileNumber
                      }
                    />
                  )}

                  <Button
                    variant={"contained"}
                    onClick={handleSubmit}
                    sx={styles.getOTP}
                  >
                    {showOTPInput ? "Verify" : "Get OTP"}
                  </Button>
                </Box>
              )}
            </Formik>
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Auth;
